import { OrderCommonService } from 'modules/sales/common/services';
import { IOrder, IShipping } from 'modules/sales/common/interfaces/IOrder';
import { ApiClientService, RequestConfig } from '@dfl/react-security';
import { format } from 'date-fns';
import fileDownload from 'js-file-download';
import { IPaymentInfo } from 'modules/sales/common/interfaces/IPaymentInfo';

class PaidOrderService extends OrderCommonService<IOrder> {
  validateBulk = (params: any, config?: any): any => {
    return ApiClientService.post(this.getPath('/validate'), params, config);
  };

  updateShipping = (id: string | undefined, values: Partial<IShipping>): any => {
    if (id) {
      return this.handleResponse(ApiClientService.patch(this.getPath(`/${id}/shipping`), values));
    }
  };

  updateShippingAndValidate = (id: string | undefined, values: Partial<IShipping>): any => {
    if (id) {
      return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/shipping/validate`), values));
    }
  };

  searchOrdersByClient = (id: string, params?: any, config?: any) => {
    return this.handleResponse(ApiClientService.post(`/ms-sales/api/costumer/${id}/orders/search`, params, config));
  };

  getOneOrderByClient = (client: string, id: string) => {
    return this.handleResponse(ApiClientService.get(`/ms-sales/api/costumer/${client}/orders/${id}`));
  };

  complete = (id: string, params?: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/complete`), params));
  };

  exportBill = (orderId: string, isClient?: boolean): any => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `factura${isClient ? '-de-cliente' : ''}-${time}.pdf`;
    return ApiClientService.get(this.getPath(`/${orderId}/${isClient ? 'pdf2' : 'pdf'}?admin=true`), {
      responseType: 'blob',
    }).then(({ data }) => {
      fileDownload(data, name);
    });
  };

  findPaymentTraces = (orderId: string, params?: any, config?: RequestConfig): Promise<IPaymentInfo> => {
    return this.handleResponse(
      ApiClientService.post(`/ms-sales/api/payment-traces/order/${orderId}/search`, params, config),
    );
  };

  findCancelledOrdersByCustomer = (clientId: string, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(`/ms-sales/api/payment-traces/customer/${clientId}/cancelled-orders/search`, params, config),
    );
  };

  fraudReport = (params: { user: string; order?: string }) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/report-fraud'), params));
  };
}

export default new PaidOrderService('/ms-sales/api/orders');
